// extracted by mini-css-extract-plugin
export var button = "_cq-4";
export var hasDarkBackground = "_cq-7";
export var hasLightBackground = "_cq-6";
export var iconWrapper = "_cq-0";
export var large = "_cq-2";
export var medium = "_cq-1";
export var small = "_cq-5";
export var xsmall = "_cq-3";